import { Form } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { isEqual } from 'lodash';
import React from 'react';
import i18n from '../../../i18n/config';
import { ErrorMessages, ModalBaseProps } from '../../../shared';
import { HasModal, HasParagraph, HasTextInput } from '../../atoms';

interface PermissionInviteProps extends ModalBaseProps<string> {}

interface PermissionInviteState {
  updateInProgress: boolean;
}

class HasPermissionInviteModal extends React.Component<PermissionInviteProps, PermissionInviteState> {
  state = { updateInProgress: false };

  private formRef = React.createRef<FormInstance>();

  componentDidUpdate(prevProps: Readonly<PermissionInviteProps>) {
    if (!isEqual(prevProps, this.props)) {
      this.setState({ updateInProgress: false });
    }
  }

  onCancel = () => {
    this.formRef.current?.resetFields();
    this.props.onCancel();
  };

  onOk = (values: any) => {
    this.setState({ updateInProgress: true });
    const userEmail = values.email;
    this.props.onOk(userEmail).then(
      () => {
        this.setState({ updateInProgress: false });
        this.formRef.current?.resetFields();
      },
      () => this.setState({ updateInProgress: false })
    );
  };

  render() {
    const { visible } = this.props;
    return (
      <HasModal
        title={
          <React.Fragment>
            <HasParagraph content={i18n.t('permission.inviteUser.message')} style={{ marginBottom: '10px' }} />
            <HasParagraph
              content={i18n.t('permission.inviteUser.description')}
              style={{ fontSize: '12px', margin: 0, fontWeight: 400 }}
            />
          </React.Fragment>
        }
        okText={i18n.t('permission.invite')}
        cancelText={i18n.t('shared.cancel')}
        onCancel={this.onCancel}
        closable={false}
        visible={visible}
        okButtonProps={{ loading: this.state.updateInProgress, htmlType: 'submit', form: 'permission-invite-form' }}
        cancelButtonProps={{ disabled: this.state.updateInProgress }}
      >
        <Form
          id="permission-invite-form"
          ref={this.formRef}
          onFinish={this.onOk}
          hideRequiredMark
          layout="vertical"
          style={{ padding: '0px 80px' }}
        >
          <Form.Item
            name="email"
            colon={false}
            hasFeedback
            rules={[
              { required: true, message: ErrorMessages.INPUT_REQUIRED(i18n.t('shared.emailAddress').toLowerCase()) },
              { whitespace: true, message: ErrorMessages.INPUT_REQUIRED(i18n.t('shared.emailAddress').toLowerCase()) },
              { type: 'email', message: ErrorMessages.EMAIL_INVALID },
            ]}
          >
            <HasTextInput key="email" size="large" />
          </Form.Item>
        </Form>
      </HasModal>
    );
  }
}

export default HasPermissionInviteModal;
